import type { SessionEvent, SessionMeta } from "./types"

export interface TransportTargets {
  ingestUrl: string
  finalizeUrl: string
  replayUrl: string
}

async function postJson(url: string, body: unknown, keepalive = false): Promise<void> {
  await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    ...(keepalive ? { keepalive: true } : {}),
  })
}

export class Transport {
  constructor(
    private targets: TransportTargets,
    private meta: SessionMeta,
  ) {}

  updateMeta(partial: Partial<SessionMeta>): void {
    Object.assign(this.meta, partial)
  }

  async sendJourney(events: SessionEvent[]): Promise<void> {
    await postJson(this.targets.ingestUrl, {
      session_id: this.meta.session_id,
      visitor_id: this.meta.visitor_id,
      project_id: this.meta.project_id,
      service_name: this.meta.service_name || "",
      started_at: this.meta.started_at,
      user_agent: this.meta.user_agent,
      device: this.meta.device,
      screen_size: this.meta.screen_size,
      user_id: this.meta.user_id || "",
      user_email: this.meta.user_email || "",
      user_traits: this.meta.user_traits || {},
      referrer: typeof document !== "undefined" ? document.referrer || "" : "",
      events,
    })
  }

  async sendReplay(events: unknown[], chunkIndex: number): Promise<void> {
    await postJson(this.targets.replayUrl, {
      session_id: this.meta.session_id,
      visitor_id: this.meta.visitor_id,
      chunk_index: chunkIndex,
      events,
    })
  }

  beaconFinalize(payload: Record<string, unknown>): boolean {
    const fullPayload = {
      ...payload,
      service_name: this.meta.service_name || "",
      user_id: this.meta.user_id || "",
      user_email: this.meta.user_email || "",
      user_traits: this.meta.user_traits || {},
    }
    const body = new Blob([JSON.stringify(fullPayload)], { type: "application/json" })
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      return navigator.sendBeacon(this.targets.finalizeUrl, body)
    }
    void postJson(this.targets.finalizeUrl, fullPayload, true).catch(() => undefined)
    return true
  }
}
